import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { VersionComponent } from '../../components/version/version.component';
import { HasAccessDirective } from '@shared/directives/has-access.directive';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { StorageService } from '@core/services/storage/storage.service';
import { ApplicationConfigService } from '@core/services/application-config/application-config.service';
import { DemoHeaderComponent } from '../../components/demo-header/demo-header.component';
import { NgClass } from '@angular/common';
import { OverlayService } from '@core/services/overlay/overlay.service';
import { IssueReportComponent } from '../../components/issue-report/issue-report.component';

@Component({
  selector: 'hd-main-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    RouterLink,
    TranslateModule,
    VersionComponent,
    HasAccessDirective,
    SideMenuComponent,
    DemoHeaderComponent,
    NgClass,
  ],
  templateUrl: './main-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainLayoutComponent implements OnInit {
  protected userEmail = inject(StorageService).getUserEmail();
  private appConfigService = inject(ApplicationConfigService);
  private overlayService = inject(OverlayService);
  protected demoMode = false;

  ngOnInit() {
    // TODO refactor to get the config in a more suitable place (note: the user needs to be authenticated for it)
    this.appConfigService.getConfig();
  }

  protected openIssueReporter() {
    this.overlayService.render(IssueReportComponent);
  }
}
